import { render, staticRenderFns } from "./three-d-secure.vue?vue&type=template&id=30cbbf9a&"
import script from "./three-d-secure.vue?vue&type=script&lang=js&"
export * from "./three-d-secure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports